import { c as _c } from "react/compiler-runtime";
import { useAcxiomDataCollection } from './hooks/useAcxiomDataCollection';

// Fires the Acxiom data-collection request once per page view. Rendered inside
// SegmentPageView because the hook reads the pageViewId from its context.
export function AcxiomDataCollection(t0) {
  const $ = _c(2);
  const {
    slug
  } = t0;
  let t1;
  if ($[0] !== slug) {
    t1 = {
      slug
    };
    $[0] = slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useAcxiomDataCollection(t1);
  return null;
}